import { inlineMediaQueryMixin, token } from "@zillow/constellation";
const ATTRIBUTES = ["background-color", "font-color"];
const colorCardCSS = (props) => {
  const styles = [];
  Object.keys(props).forEach((prop) => {
    const attr = prop.replace(/[A-Z]/g, (char) => `-${char.toLowerCase()}`);
    if (ATTRIBUTES.indexOf(attr) >= 0) {
      styles.push(inlineMediaQueryMixin(prop, (mediaProps) => {
        const value = mediaProps[prop];
        if (attr === "font-color") {
          return token(`colors.${value}`, (color) => {
            if (color) {
              return `color: ${color};`;
            }
            return "";
          });
        }
        if (attr === "background-color") {
          return token(`colors.${value}`, (color) => {
            if (color) {
              return `background-color: ${color};`;
            }
            return "";
          });
        }
        return `${attr}: ${value};`;
      })(props));
    }
  });
  return styles;
};
const ColorCardMixin = (props) => [colorCardCSS(props)];
export {
  ColorCardMixin
};
